import { FileClient, RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B080040FindRequest = { shukashijiYmd: string } & Partial<{
  shijikaisu: string;
  batchNo: string;
  page: number;
  sort: string[];
  size: number;
}>;
export type B080040FindResponse = {
  shukashijiYmd: string;
  shijiKaisu: string;
  batchNo: string;
  batchNm: string;
  tenposu: string;
  shohinsu: string;
  shukajokyo: string;
  pickinghako: string;
};

//検索処理
export const B080040Find = (props: B080040FindRequest) => {
  return RestClient.get<PageableResponse<B080040FindResponse[]>>(
    "b080040/find",
    {
      params: props,
    }
  );
};

export type B080040PrintDetailRequest = Partial<{
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
  shukajokyo: number;
  cancelKbn: number;
  version: string;
}>;

export type B080040PrintRequest = {
  b080040PrintRequestChildList: B080040PrintDetailRequest[];
};

//印刷処理
export const B080040Print = (props: B080040PrintRequest) => {
  return FileClient.put("b080040/print", props);
};
